<nav class="custom-footer-menu py-1" *ngIf="campus">

    <div class="container py-2">

        <div class="row mb-3">

            <!-- Logos -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-md-0">
                
                <div class="d-flex flex-column flex-md-row justify-content-center justify-content-lg-end align-items-center h-100 w-100">
                    <a [href]="urlPartner" target="_blank">
                        <img class="custom-footer-menu-logo-partner me-4" [src]="logoPartner"></a>
                    <a [href]="urlFSS" target="_blank">
                        <img class="custom-footer-menu-logo-fss mt-3 mt-sm-2 mt-md-0" [src]="logoFSS"></a>
                </div>

            </div>

            <!-- Contacto -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">

                <div class="d-flex flex-column flex-md-row justify-content-center justify-content-lg-start align-items-center h-100 w-100">

                    <div class="d-flex flex-column justify-content-start align-items-center">

                        <div class="w-100 fs-5 mb-2">
                            <fa-icon [icon]="['fas', 'phone-alt']" class="me-2"></fa-icon>
                            {{ phone }} <small>({{ schedule }})</small>
                        </div>
                        <div class="w-100 fs-5 mb-2">
                            <fa-icon [icon]="['fas', 'envelope']" class="me-2"></fa-icon>
                            <a href="mailto:{{mail}}" target="_blank">
                                {{mail}}
                            </a>
                        </div>
                        <div class="w-100 fs-2 mb-0 text-center text-lg-start">
                            <a *ngIf="facebook" [href]="facebook" target="_blank" class="me-3">
                                <fa-icon [icon]="['fab', 'facebook-square']"></fa-icon>
                            </a>
                            <a *ngIf="instagram" [href]="instagram" target="_blank">
                                <fa-icon [icon]="['fab', 'instagram']"></fa-icon>
                            </a>
                        </div>
    
                    </div>

                </div>

                

            </div>

        </div>

        <div class="row">

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">

                <!-- Copyright -->
                <div class="d-flex flex-column justify-content-center align-items-center w-100 text-center text-wrap">
                    <small>© {{ campusYear }}. {{ this.campus.name }}.</small>
                    <small>Todos los derechos reservados.</small>
                </div>
                <div class="d-flex flex-row justify-content-center align-items-center w-100 text-center">
                    <a class="me-3" [routerLink]="['./', urlLegalAdvice]">Aviso legal</a> |
                    <a class="ms-3" [routerLink]="['./', urlCookiesPolicy]">Política de cookies</a>
                </div>

            </div>

        </div>

    </div>

</nav>